<template>
  <div class="tc-box" v-if="show" @click="show = false">
  	<div class="tc-box-model" @click.stop>
  		<div class="tc-box-model-top">
  			<div class="tc-box-model-top-div"></div>
  			<div class="tc-box-model-top-title">{{$t('all.tishi')}}</div>
			<img src="../../assets/image/wode_jiazu@2x.png" alt="" @click="show = false"/>
  		</div>
		<div class="tc-box-model-center">{{$t('all.quedingtuichudengluma')}}？</div>
		<div class="tc-box-model-bottom" @click="logout">{{$t('all.queding')}}</div>
  	</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
	  show:false,
    };
  },
  mounted() {
	
  },
  methods: {
	showModel(){
		this.show = true
	},
    //退出登录
	logout(){
		this.$router.replace('/login');
		sessionStorage.setItem('user', null);
		this.$store.commit('changeToken', null); // 调用 setCount mutation 并传递参数
		setTimeout(() => {
			window.history.pushState(null, null, '/login');
			window.addEventListener('popstate', () => {
			window.history.pushState(null, null, '/login');
			});
		}, 100);
	}
  }
};
</script>
<style scoped lang="scss">
	@import "./tuichudenglu.css";
</style>


// WEBPACK FOOTER //
// tuichudenglu.vue?1e98bdd0